var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0518 0.37401C10.3004 0.68361 10.3422 1.11093 10.1585 1.46287C9.49693 2.72992 9.12244 4.1711 9.12244 5.70268C9.12244 10.7698 13.2302 14.8776 18.2974 14.8776C19.8289 14.8776 21.2701 14.5031 22.5372 13.8416C22.8891 13.6578 23.3164 13.6997 23.626 13.9482C23.9356 14.1968 24.0689 14.6049 23.9655 14.9883C22.5664 20.1789 17.8269 24 12.1924 24C5.45873 24 0 18.5413 0 11.8076C0 6.17312 3.82118 1.43366 9.01176 0.0345065C9.3951 -0.0688263 9.80327 0.0644101 10.0518 0.37401ZM7.51753 2.74783C4.23979 4.44266 2 7.86447 2 11.8076C2 17.4367 6.5633 22 12.1924 22C16.1356 22 19.5574 19.7603 21.2522 16.4825C20.3105 16.7401 19.3195 16.8776 18.2974 16.8776C12.1256 16.8776 7.12244 11.8744 7.12244 5.70268C7.12244 4.68052 7.25992 3.68959 7.51753 2.74783Z",
    style: {
      fill: "var(--color, currentColor)",
      stroke: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.2c2df99f.svg";
export { ForwardRef as ReactComponent };